"use strict";
exports.__esModule = true;
exports.ADD_FUNDS_ERROR_HANDLING = void 0;
exports.ADD_FUNDS_ERROR_HANDLING = {
    DEPOSIT_LIMIT_MODAL: {
        HEADER: 'Deposit limit reached',
        BODY_LINE_1: 'You’ve already made 3 deposits within the last 30 days.',
        DEPOSIT_DISCLAIMER: 'You’ll be eligible to make your next deposit on {{nextEligibleDepositDate}}.',
        CTA: 'Close'
    }
};
